import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Language = 'fr' | 'en' | 'mg';

interface SettingsState {
  musicEnabled: boolean;
  soundEffectsEnabled: boolean;
  language: Language;
  notificationsEnabled: boolean;
  setMusicEnabled: (enabled: boolean) => void;
  setSoundEffectsEnabled: (enabled: boolean) => void;
  setLanguage: (language: Language) => void;
  setNotificationsEnabled: (enabled: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      musicEnabled: true,
      soundEffectsEnabled: true,
      language: 'fr',
      notificationsEnabled: false,
      setMusicEnabled: (enabled) => {
        set({ musicEnabled: enabled });
      },
      setSoundEffectsEnabled: (enabled) => {
        set({ soundEffectsEnabled: enabled });
      },
      setLanguage: (language) => {
        set({ language: language });
      },
      setNotificationsEnabled: (enabled) => {
        set({ notificationsEnabled: enabled });
      }
    }),
    {
      name: 'ludoka-settings'
    }
  )
);
